import { NgClass } from '@angular/common';
import {
  Component,
  inject,
  Input,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import {
  FormGroup,
  NonNullableFormBuilder,
  ReactiveFormsModule,
} from '@angular/forms';
import { ControlsOf } from '@shared/models-v3/controls-of.type';
import { RadioButtonModule } from 'primeng/radiobutton';
import { PaymentDocumentTypeOption } from './models/payment-document-type-option.interface';
import { SessionService } from '@core/services-v2/session/session.service';
import { ISession } from '@core/models-v2/auth/session.interface';
import { PaymentDocumentType } from '@core/enums/payment-document-type.enum';

const NG_MODULES = [ReactiveFormsModule, NgClass];
const PRIME_MODULES = [RadioButtonModule];

@Component({
  selector: 'app-document-type-form',
  standalone: true,
  imports: [NG_MODULES, PRIME_MODULES],
  templateUrl: './document-type-form.component.html',
  styleUrl: './document-type-form.component.scss',
  host: { class: 'w-full' },
})
export class DocumentTypeFormComponent implements OnInit {
  //#region Inputs & Outputs
  @Input() paymentDocumentType!: PaymentDocumentType;
  @Output() onChange: EventEmitter<PaymentDocumentType> = new EventEmitter();
  //#endregion

  paymentDocumentTypes: PaymentDocumentTypeOption[] = [
    { title: 'Boleta', value: PaymentDocumentType.RECEIPT },
    { title: 'Factura', value: PaymentDocumentType.INVOICE },
  ];
  paymentDocumentTypeForm!: FormGroup<
    ControlsOf<{ documentType: PaymentDocumentType }>
  >;
  isLoggedIn = false;
  userSession!: ISession;

  //#region Getters
  get paymentDocumentTypeField() {
    return this.paymentDocumentTypeForm.get('documentType');
  }
  //#endregion

  //#region Dependencies
  private readonly fb = inject(NonNullableFormBuilder);
  private readonly sessionService = inject(SessionService);
  //#endregion

  constructor() {
    this.isLoggedIn = this.sessionService.isLoggedIn();
  }

  ngOnInit(): void {
    this.userSession = this.sessionService.getSession()!;
    this.buildForm();
  }

  private buildForm(): void {
    this.paymentDocumentTypeForm = this.fb.group({
      documentType: this.paymentDocumentType,
    });
  }

  /**
   * Al seleccionar el tipo de documento de pago.
   * @param type - Tipo de documento seleccionado.
   */
  onSelectPaymentDocumentType(type: PaymentDocumentType): void {
    this.paymentDocumentTypeForm.setValue({ documentType: type });
    this.onChange.emit(type);
  }
}
